module.exports = __webpack_public_path__ + "media/offers_icons/osobowe-white-b1828c9d.svg";